"use client";
import TypeWriter from "@/components/common/TypeWriter";
import Image from "next/image";
import { useState } from "react";
import ModalVideo from "react-modal-video";
export default function Hero2() {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className="container min-height-100vh d-flex align-items-center pt-100 pb-100 pt-sm-120 pb-sm-120">
        {/* Home Section Content */}
        <div className="home-content text-start">
          <div className="row">
            {/* Home Section Text */}
            <div className="col-md-10 offset-md-1 col-lg-6 offset-lg-0 d-flex align-items-center mb-md-60 mb-sm-30">
              <div className="w-100 text-center text-lg-start">
                {/* wow fadeInUp */}
                <span className="section-caption mb-30 mb-xs-10 !text-[#ffcd5a]">
                  {/* Resonance Creative Studio */}
                  Simplify. Automate. Grow
                </span>
                {/* wow fadeInUp */}
                <h1 className="hs-title-8 mb-40 mb-sm-20 " 
                style={{ color: "#0044cc" }}
                >
                  {/* Create your beautiful web presence */}
                  Run Your Business Smarter with GetBiz Solutions
                  <span className="visually-hidden">easy, fast, smart</span>
                  <TypeWriter
                    colorClass=""
                    strings={["easily", "fast", "smart"]}
                  />
                </h1>
                {/* wow fadeInUp */}
                <p
                  className="section-descr mb-50 text-white"
                  style={{ color: "#ffffff" }}
                  data-wow-delay="0.2s"
                >
                  Optimize your operations, enhance productivity, and drive growth with GetBiz Solutions.
                </p>
                {/* wow fadeInUp */}
                <div
                  className="local-scroll mt-n10  wch-unset"
                  data-wow-delay="0.4s"
                  data-wow-offset={0}
                >
                  {/* <a
                    href="/contactus/"
                    className="btn btn-mod btn-large btn-round btn-hover-anim align-middle mt-10"
                  >
                    <span>See All Apps</span>
                  </a> */}
                  <a
                    href="/pricing/"
                    className="btn btn-mod btn-grad btn-large btn-round mb-xs-10 "
                    data-btn-animate="y"
                    style={{
                      transition: 'box-shadow 0.3s ease',
                      boxShadow: 'none',
                      ':hover': {
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                      }
                    }}
                  >
                    Start 15 Days Trial
                  </a>
                  <a
                    href="/book-demo/"
                    className="link-hover-anim  ms-2 ms-sm-5 me-2"
                    data-link-animate="y"
                  >
                    <span className="link-strong link-strong-unhovered">
                      Book A Demo{" "}
                      <i
                        className="mi-arrow-right size-24"
                        aria-hidden="true"
                      ></i>
                    </span>
                    <span
                      className="link-strong link-strong-hovered"
                      aria-hidden="true"
                    >
                      Book A Demo{" "}
                      <i
                        className="mi-arrow-right size-24"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </a>

                </div>
              </div>
            </div>
            {/* End Home Section Text */}
            {/* Images */}
            <div className="col-lg-6 d-flex align-items-center">
              {/* wow fadeInLeft */}
              <div
                className="w-100 ps-xl-3 "
                data-wow-delay="0.15s"
              >
                <Image
                  width={680}
                  height={598}
                  // src="/assets/images/img/slides/hrms_slide.png"
                  src="/assets/images/img/slides/hero_image.png"
                  // src="/assets/images/hs-image-2.jpg"
                  alt="Getbiz Solutions Hrms Image"
                />
                {/* <video
                  style={{
                    position: 'relative',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    // objectFit: 'cover',
                    // zIndex: -1,
                    // overflow: 'hidden',
                  }}
                  autoPlay
                  muted
                  noloop
                  className="border border-gray"
                  src="/assets/images/home2.mp4"
                  alt="GetBiz Solutions Hero Image"
                >
                </video> */}

                {/* <div className="composition-4">
                  <div className="composition-4-decoration-1 opacity-65">
                    <Image
                      width="148"
                      height="148"
                      className="svg-shape"
                      src="/assets/images/decoration-3.svg"
                      alt=""
                    />
                  </div>
                  <div className="composition-4-image-1">
                    <div className="composition-4-image-1-inner">
                      <Image
                        width={850}
                        height={834}
                        src="/assets/images/hs-image-1.jpg"
                        alt="Image Description"
                      />
                    </div>
                  </div>
                  <div className="composition-4-image-2">
                    <div className="composition-4-image-2-inner">
                      <Image
                        width={570}
                        height={598}
                        src="/assets/images/hs-image-2.jpg"
                        alt="Image Description"
                      />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            {/* End Images */}
          </div>
        </div>
        {/* End Home Section Content */}
        {/* Scroll Down */}
        {/* wow fadeInUp */}
        <div
          className="local-scroll scroll-down-wrap-type-1 "
          data-wow-offset={0}
        >
          <div className="container">
            <a href="#about" className="scroll-down-1">
              <div className="scroll-down-1-icon">
                <i className="mi-arrow-down" />
              </div>
              <div className="scroll-down-1-text">Scroll Down</div>
            </a>
          </div>
        </div>
        {/* End Scroll Down */}
      </div>{" "}
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="jTea_8Fk5Ns"
        onClose={() => setOpen(false)}
      />{" "}

      {/* Cal "Book my Cal" floating button is now mounted site-wide from the
          root layout (components/common/CalFloatingButton), so it's no longer
          rendered here (avoids registering the floating button twice on home). */}

    </>
  );
}
